document.addEventListener('DOMContentLoaded', function () {

  const cardSelectors = `
    .product-card-container,
    .taste-the-purity-taste-the-purity-product-card-container,
    .card-product-action-container
  `;

  document.querySelectorAll(cardSelectors).forEach((card) => {

    const select = card.querySelector('.variant-selector');
    const button = card.querySelector('.add-to-bag-btn');

    if (!button) return;

    function updateButtonState() {

      if (!select) return;

      const selectedOption = select.options[select.selectedIndex];

      if (selectedOption.disabled) {

        button.classList.add('is-out-of-stock');
        button.disabled = true;
        button.innerText = 'Out of Stock';

      } else {

        button.classList.remove('is-out-of-stock');
        button.disabled = false;

        button.innerHTML = `
          <span class="bag-icon">
            <img src="https://cdn.shopify.com/s/files/1/0751/2142/6743/files/Bag_Icon_b843214a-bae6-4165-8d2b-75eda164c81e.svg"
            class="img_bag_icn">
          </span>
          Add to Bag
        `;
      }

    }

    updateButtonState();

    if (select) {
      select.addEventListener('change', updateButtonState);
    }

  });

});